import { ca } from '@cian/analytics';

import { getMortgageBannerCianTerm, TMortgageBannerVerticalName } from './mortgageUnderPriceCianBanner';

const TRAP_TYPE = 'object_card_last_slide_banner';
const BANNER_NAME = 'Перейти в сервис';

function getGalleryLastSlidePageExtra(verticalName: TMortgageBannerVerticalName) {
  return {
    trap_type: TRAP_TYPE,
    bannerName: BANNER_NAME,
    trapid: BANNER_NAME,
    vertical_name: verticalName,
  };
}

/** Ссылка на ipoteka-main с разметкой ловушки на последнем слайде галереи. */
export function buildGalleryLastSlideIpotekaUrl(verticalName: TMortgageBannerVerticalName): string {
  const params = new URLSearchParams({
    cian_source: 'cian',
    cian_medium: 'trap',
    cian_campaign: 'mortgage_banner',
    cian_content: TRAP_TYPE,
    cian_term: getMortgageBannerCianTerm(verticalName),
  });

  return `/ipoteka-main/?${params.toString()}`;
}

export function trackGalleryLastSlideMortgageShow(verticalName: TMortgageBannerVerticalName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_banner',
    useLastProducts: true,
    page: {
      extra: getGalleryLastSlidePageExtra(verticalName),
    },
  });
}

export function trackGalleryLastSlideMortgageClick(verticalName: TMortgageBannerVerticalName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_banner',
    useLastProducts: true,
    page: {
      extra: getGalleryLastSlidePageExtra(verticalName),
    },
  });
}
